<template><LayOut /></template>
<script>
import LayOut from "@/components/Layout/LayOut.vue";
export default {
  components: { LayOut },
};
</script>

<style>
/* Global overflow handling to prevent double scrollbars */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

#app {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}
</style>
